module.exports = __webpack_public_path__ + "img/3_of_Spades.svg.c396bc83.png";